/**
 * PATIENT VARIABLES
 * 
 * Variables relacionadas con datos del paciente.
 */

import { TemplateVariable } from '../types';

const now = new Date().toISOString();

export const PATIENT_VARIABLES: Omit<TemplateVariable, 'id' | 'createdAt' | 'updatedAt'>[] = [
    {
        templateKey: 'nombre_paciente',
        displayName: 'Nombre del paciente',
        description: 'Nombre completo del paciente',
        category: 'patient',
        icon: '👤',
        example: 'María García López',
        fallback: 'Paciente',
        dataType: 'string',
        required: true,
        availableIn: ['ai_agent', 'email_template', 'notification', 'sms', 'whatsapp', 'instagram', 'practice', 'report'],
        searchTags: ['nombre', 'paciente', 'usuario', 'name', 'client'],
        sortOrder: 1,
        active: true,
        isSystem: true,
    },
    {
        templateKey: 'email_paciente',
        displayName: 'Email del paciente',
        description: 'Dirección de correo electrónico del paciente',
        category: 'patient',
        icon: '📧',
        example: 'maria@ejemplo.com',
        fallback: '',
        dataType: 'string',
        required: false,
        availableIn: ['email_template', 'report'],
        searchTags: ['email', 'correo', 'mail'],
        sortOrder: 2,
        active: true,
        isSystem: true,
    },
    {
        templateKey: 'telefono_paciente',
        displayName: 'Teléfono del paciente',
        description: 'Número de teléfono del paciente',
        category: 'patient',
        icon: '📱',
        example: '+34 612 345 678',
        fallback: '',
        dataType: 'string',
        required: false,
        availableIn: ['sms', 'whatsapp', 'report'],
        searchTags: ['telefono', 'phone', 'movil', 'celular'],
        sortOrder: 3,
        active: true,
        isSystem: true,
    },
    {
        templateKey: 'fecha_inicio',
        displayName: 'Fecha de inicio del proceso',
        description: 'Cuándo comenzó el proceso terapéutico',
        category: 'patient',
        icon: '📅',
        example: '15 de enero de 2024',
        fallback: 'No disponible',
        dataType: 'date',
        required: false,
        availableIn: ['ai_agent', 'report'],
        searchTags: ['fecha', 'inicio', 'comienzo', 'start'],
        sortOrder: 4,
        active: true,
        isSystem: true,
        metadata: {
            dateFormat: 'DD de MMMM de YYYY',
        },
    },
    {
        templateKey: 'dias_proceso',
        displayName: 'Días en proceso',
        description: 'Número de días desde el inicio del proceso terapéutico',
        category: 'patient',
        icon: '⏱️',
        example: '45',
        fallback: '0',
        dataType: 'number',
        required: false,
        availableIn: ['ai_agent', 'report'],
        searchTags: ['dias', 'tiempo', 'duracion', 'days'],
        sortOrder: 5,
        active: true,
        isSystem: true,
    },
    {
        templateKey: 'proxima_cita',
        displayName: 'Próxima cita',
        description: 'Fecha y hora de la próxima cita programada',
        category: 'patient',
        icon: '🗓️',
        example: 'Viernes 5 de enero a las 10:00',
        fallback: 'Sin cita programada',
        dataType: 'date',
        required: false,
        availableIn: ['email_template', 'notification', 'sms', 'whatsapp'],
        searchTags: ['cita', 'sesion', 'appointment', 'next'],
        sortOrder: 6,
        active: true,
        isSystem: true,
    },
    {
        templateKey: 'ultima_sesion',
        displayName: 'Última sesión',
        description: 'Fecha de la última sesión realizada',
        category: 'patient',
        icon: '📆',
        example: '28 de diciembre de 2024',
        fallback: 'Sin sesiones anteriores',
        dataType: 'date',
        required: false,
        availableIn: ['ai_agent', 'email_template', 'report'],
        searchTags: ['ultima', 'anterior', 'last', 'previous'],
        sortOrder: 7,
        active: true,
        isSystem: true,
    },
];
